<div class="dialog dialog--how how">
  <h3 class="how__title">How to win?</h3>
  <div class="how__content">
    <bingo-how-to-win-tutorial />
  </div>
  <footer class="dialog__footer">
    <button type="button" mat-flat-button color="primary" class="btn btn--submit" (click)="closeDialog()">Got It</button>
  </footer>
</div>
